import GeneralServices from "./GeneralServices";

import { IGetRelationShipsOK } from "./ConstantsServices.dto";
import { BaseServiceRequestDto } from "./dto/request/BaseServiceRequest.dto";
import { CatchErrorType, IResponseError } from "./dto/response/CommonResponse.dto";

class ConstantsServices {
  private handleError = (error: unknown, defaultMessage: string): IResponseError => {
    const typedError = error as CatchErrorType;
    const errorMsg = typedError.data && typedError.data.message;
    return {
      ok: false,
      message: typeof errorMsg === "string" ? errorMsg : defaultMessage,
    };
  };

  getCountries = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: (args.loader && args.loader) === false ? false : true,
        endpoint: `countries${args.params ? '?' + args.params.join("&") : ''}`,
      });
      return response.data;
    }
    catch (err) {
      return [];
    }
  }

  getPolicySpecialties = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: (args.loader && args.loader) === false ? false : true,
        endpoint: `policy-specialties${args.description ? '?description=' + args.description : ''}`,
      });
      return response.data;
    }
    catch (err) {
      console.log(err);
      return {};
    }
  }

  getLifeQuestionnaires = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: (args.loader && args.loader) === false ? false : true,
        endpoint: 'senda/lifeQuestionnaires',
      });
      return response.data;
    }
    catch (err) {
      return [];
    }
  }

  getActivities = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: (args.loader && args.loader) === false ? false : true,
        endpoint: `senda/riskActivities${args.params ? '?' + args.params.join("&") : ''}`,
      });
      return response.data;
    }
    catch (err) {
      return [];
    }
  }

  getCompanies = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: (args.loader && args.loader) === false ? false : true,
        endpoint: `senda/getCompaniesList`,
      });
      return response.data;
    }
    catch (err) {
      return [];
    }
  }

  getRelationShips = async (
    args: BaseServiceRequestDto
  ): Promise<IGetRelationShipsOK | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: !!args.loader,
        endpoint: `static-lists/getRelationships`,
      });

      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return this.handleError(
        error,
        "Error en la recuperación de parentesco del representante legal."
      );
    }
  };
}

export default new ConstantsServices();